<template>
	<div class="site">
		<!--顶部导航-->
		<Nav/>
		<!--首页大图 只在首页且pc端时显示-->
		<!-- <div class="m-mobile-hide">
			<Header v-if="$route.name==='home'" :blogName="siteInfo.blogName" />
		</div> -->
		<div style="display: flex;position: relative;padding: 10px;width: 100%;background-color: #fff;	
    flex-direction: column;">
			<div style="margin-block-end: 20px;text-align: center;margin-left:auto;margin-right:auto;margin-bottom: 20px;width:100%;max-width: 1548px;--widgets-spacing: 20px 20px;">
				<img src="../../src/assets/images/main-new.jpg" style="max-width: 100%;width: 100%;
					border: none;
					border-radius: 0;
					box-shadow: none;
					height: 400px;
					object-fit: cover;
					object-position: center center;
					vertical-align: middle;
    				display: inline-block;">
			</div>
			<div style="height: 30px;margin-bottom: 20px;"></div>
			<div class="search-container" style="display: flex;align-items: center;justify-content: center;flex-direction: column;margin-bottom: 20px;padding: 10px;">
				<h3 style="font-size: 28px;font-style: normal;margin-bottom: 20px;">Search CRM Products</h3>
				<div style="display: flex;box-sizing: border-box;">
					<!-- <el-autocomplete v-model="queryString" :fetch-suggestions="debounceQuery" placeholder="Search Here ..."
									class=" m-search" :class="{'m-mobile-hide': mobileHide}"
									popper-class="m-search-item" @select="handleSelect"> -->
					<el-autocomplete v-model="queryString" :fetch-suggestions="debounceQuery" placeholder="Search Here ..."
						class="m-search"
						popper-class="m-search-item" @select="handleSelect">	
						<template slot-scope="{ item }">
							<div class="title">{{ item.title }}</div>
							<span class="content">{{ item.content }}</span>
						</template>
					</el-autocomplete>
					<button style="cursor:pointer;color:#fff;width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;background-color: #2c3e50;border:none;border-radius: 8px;">
						<svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.1249 16.2411L12.4049 11.5211C13.5391 10.1595 14.1047 8.41291 13.9841 6.64483C13.8634 4.87675 13.0657 3.22326 11.7569 2.02834C10.4482 0.833415 8.7291 0.189061 6.95736 0.229318C5.18562 0.269575 3.49761 0.991344 2.24448 2.24448C0.991344 3.49761 0.269575 5.18562 0.229318 6.95736C0.189061 8.7291 0.833415 10.4482 2.02834 11.7569C3.22326 13.0657 4.87675 13.8634 6.64483 13.9841C8.41291 14.1047 10.1595 13.5391 11.5211 12.4049L16.2411 17.1249L17.1249 16.2411ZM1.49989 7.12489C1.49989 6.01237 1.82979 4.92483 2.44787 3.99981C3.06596 3.07478 3.94446 2.35381 4.97229 1.92807C6.00013 1.50232 7.13113 1.39093 8.22227 1.60797C9.31342 1.82501 10.3157 2.36074 11.1024 3.14741C11.889 3.93408 12.4248 4.93636 12.6418 6.02751C12.8588 7.11865 12.7475 8.24965 12.3217 9.27748C11.896 10.3053 11.175 11.1838 10.25 11.8019C9.32495 12.42 8.23741 12.7499 7.12489 12.7499C5.63355 12.7482 4.20377 12.1551 3.14924 11.1005C2.09471 10.046 1.50154 8.61622 1.49989 7.12489Z" fill="currentColor"></path></svg>
					</button>
				</div>
				<!-- <button class="ui menu black icon button m-right-top m-mobile-show" @click="toggle">
					<i class="sidebar icon"></i>
				</button> -->
			</div>
			<div style="height: 10px;"></div>
		</div>
		<div style="display: flex;background-color: #fff;padding: 24px 0px 100px 0px;">
			<div style="display: flex;flex-wrap: wrap;margin-right: auto;margin-left: auto;position: relative;max-width: 1548px;">
				<div class="carousel-container">
					<el-carousel ref="slideCarousel" height="723px" arrow="never" :autoplay="false" :loop="true" style="padding: 0px 12px 0px 12px;border-radius: 10px;">
						<el-carousel-item class="custom-carousel-item" v-for="item in randomBlogList"  :key="item.id" style="border-radius: 10px;text-align: center; overflow: hidden;">
							<div class="carousel-bg" 
								:style="{
									backgroundImage: `url(${item.firstPicture})`,
								}">
							</div>
							<div class="gradient-overlay"></div>
							<div style="margin-top: 25px;position: absolute;left: 0;bottom: 60px;width: 100%;z-index: 2;transition: all 0.5sease;padding: 25px 40px;">
								<div class="post-terms">
									<div class="rt-cat-1">				
										<router-link :to="`/category/${item.category.name}`" @click.stop>
											<span class="category-style" style="background:#111111">{{ item.category.name }}</span>
										</router-link>
									</div>																													
									<div class="rtrs-rating-item">
										<div class="rating-icon">
											<el-rate
												v-model="item.rate"
												disabled
												show-score
												text-color="#fff"
												score-template="{value} / 5">
												</el-rate>
										</div>
									</div>
								</div>
								<h3 style="color: #fff;font-size: 32px;">{{ item.title }}</h3>
								<div style="color: #fff;font-size: 14px;font-weight: 500;">{{ formatDate(item.createTime) }}</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="aside-container" style="display: flex;	position: relative;min-height: 1px;">
					<div class="aside-inner" style="position: relative;
						padding: 0px 12px 0px 12px;
						width: 100%;
						display: flex;
						flex-wrap: wrap;
						align-content: flex-start;">
						<div class="row">
							<div class="col-lg-6">
								<div class="row">
									<div class="col-12" @click="handleClick($event, item)" v-for="(item,index) in topBlogList.slice(0, 3)" :key="item.id" style="position: relative;"
									:style="{ marginTop: index > 0 ? '18px' : '0px' }">
										<div class="image-wrapper" style="position: relative;overflow: hidden;border-radius: 10px;">
											<img class="blog-image" :src="item.firstPicture" >
											<div class="gradient-overlay"></div>
											<div style="position: absolute;
												left: 0;
												bottom: 0;
												width: 100%;
												z-index: 2;
												transition: all 0.5sease;
												padding: 25px;">
												<div style="display: inline-flex;align-items: center;flex-wrap: wrap;gap: 15px;margin-bottom: 13px;">
													<div class="rt-cat-1">				
														<router-link :to="`/category/${item.category.name}`" @click.stop>
															<span class="category-style" style="background:#111111">{{ item.category.name }}</span>
														</router-link>
													</div>																													
													<div class="rtrs-rating-item">
														<div class="rating-icon">
															<el-rate
																v-model="item.rate"
																disabled
																show-score
																text-color="#fff"
																score-template="{value} / 5">
																</el-rate>
														</div>
													</div>
												</div>
												<h3 style="color: #fff;font-size: 22px; margin: 0px 0px 5px 0px;">{{ item.title }}</h3>
												<div style="color: #fff;font-size: 14px;font-weight: 500;margin-top: 5px;">{{ formatDate(item.createTime) }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-lg-6">
								<div class="row">
									<div class="col-13" v-for="(item,index) in topBlogList.slice(3, 5)" :key="item.id" style="position: relative;"
										:style="{ marginTop: index > 0 ? '18px' : '0px' }" @click="handleClick($event, item)">
										<div class="image-wrapper" style="position: relative;overflow: hidden;border-radius: 10px;cursor: pointer;">
											<img class="blog-right-image" :src="item.firstPicture" >
											<div class="gradient-overlay"></div>
											<div style="position: absolute;
												left: 0;
												bottom: 0;
												width: 100%;
												z-index: 2;
												transition: all 0.5sease;
												padding: 25px;">
												<div style="display: inline-flex;align-items: center;flex-wrap: wrap;gap: 15px;margin-bottom: 13px;">
													<div class="rt-cat-1">				
														<router-link :to="`/category/${item.category.name}`" @click.stop>
															<span class="category-style" style="background:#111111">{{ item.category.name }}</span>
														</router-link>
													</div>
													<div class="rtrs-rating-item">
														<div class="rating-icon">
															<el-rate
																v-model="item.rate"
																disabled
																show-score
																text-color="#fff"
																score-template="{value} / 5">
																</el-rate>
														</div>
													</div>
												</div>
												<h3 style="color: #fff;font-size: 22px; margin: 0px 0px 5px 0px;">{{ item.title }}</h3>
												<div style="color: #fff;font-size: 14px;font-weight: 500;margin-top: 5px;">{{ formatDate(item.createTime) }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="padding: 100px 0px 100px 0px;">
			<div style="max-width: 1548px;display: flex;
				margin-right: auto;
				margin-left: auto;
				position: relative;">
				<div class="most-container">
					<div style="padding: 0px 12px 0px 12px;">
						<div style="width: 100%;display: flex;flex-wrap: wrap;align-items: center;position: relative;">
							<div class="header-left">
								<div class="header-left-margin">
									<div class="header-left-center">
										<h2 style="font-size: 36px;line-height: 42px;font-style: normal;"><span class="line"></span>Most Popular Review</h2>
									</div>
								</div>
							</div>
							<div class="header-right">
								<div class="header-right-margin">
									<div class="header-right-center">
										<button class="button-style-3" @click="$router.push('/blogs')" >View All</button>
									</div>
								</div>
							</div>
						</div>
						<div class="all-container">
							<div class="row" style="max-width: 1548px;">
								<div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-mn-12" v-for="item in topBlogs" @click="handleClick($event, item)">
									<div class="rt-item">
										<div class="rt-image">
											<img class="rt-main-image" :src="item.firstPicture">
										</div>
										<div style="padding: 25px 25px 22px;">
											<div style="padding: 25px 25px 22px;position: relative;">
												<div style="font-weight:bold;display: inline-flex;align-items: center;flex-wrap: wrap;gap: 20px;margin-bottom: 13px;">
													<div class="rt-cat-1">				
														<router-link :to="`/category/${item.category.name}`" @click.stop>
															<span class="category-style" style="background: rgba(17, 17, 17, 0.1);color: #111111;font-size: 9px;">{{ item.category.name }}</span>
														</router-link>
													</div>																													
													<div class="rtrs-rating-item">
														<div class="rating-icon off">
															<el-rate
																v-model="item.rate"
																disabled
																show-score
																text-color="#777777"
																score-template="{value} / 5">
																</el-rate>
														</div>
													</div>
												</div>
												<h3 style="cursor:pointer;font-size: 20px;line-height: 1.4;margin-bottom: 7px;margin-top: 0;">{{ item.title }}</h3>
												<ul class="entry-meta">
														<!-- <li class="post-author">by <a href="https://netsparks.online/author/admin/" title="Posts by admin" rel="author">admin</a></li> -->
													<li class="post-date">{{formatDate(item.createTime)}}</li>				
													<li><span class="post-views meta-item"><span class="meta-views meta-item very-high">Views <span class="view-number">{{ item.views }}</span> </span> </span></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
		
		<!-- <div class="main">
			<div class="m-padded-tb-big">
				<div class="ui container">
					<div class="ui stackable grid">
						
						<div class="three wide column m-mobile-hide">
							<Introduction :class="{'m-display-none':focusMode}"/>
						</div>
			
						<div class="ten wide column">
							<keep-alive include="Home">
								<router-view/>
							</keep-alive>
						</div>
					
						<div class="three wide column m-mobile-hide">
							<RandomBlog :randomBlogList="randomBlogList" :class="{'m-display-none':focusMode}"/>
							<Tags :tagList="tagList" :class="{'m-display-none':focusMode}"/>
							
							<Tocbot v-if="$route.name==='blog'"/>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<!--私密文章密码对话框-->
		<!-- <BlogPasswordDialog/> -->

		<!--APlayer-->
		<!-- <div class="m-mobile-hide">
			<MyAPlayer/>
		</div> -->
		<!--回到顶部-->
		<el-backtop style="box-shadow: none;background: none;">
			<img src="/img/paper-plane.png" style="width: 40px;height: 40px;z-index: 999999;">
		</el-backtop>
		<!--底部footer-->
		<!-- <Footer :siteInfo="siteInfo" :badges="badges" :newBlogList="newBlogList" :hitokoto="hitokoto"/> -->
	</div>
</template>

<script>
	import {getHitokoto, getSite} from '@/api/index'
	import Nav from "@/components/index/Nav";
	import Header from "@/components/index/Header";
	import Footer from "@/components/index/Footer";
	import Foot from "@/components/index/Foot";
	import Introduction from "@/components/sidebar/Introduction";
	import Tags from "@/components/sidebar/Tags";
	import RandomBlog from "@/components/sidebar/RandomBlog";
	import MyAPlayer from "@/components/index/MyAPlayer";
	import Tocbot from "@/components/sidebar/Tocbot";
	import BlogPasswordDialog from "@/components/index/BlogPasswordDialog";
	import {mapState} from 'vuex'
	import {SAVE_CLIENT_SIZE, SAVE_INTRODUCTION, SAVE_SITE_INFO, RESTORE_COMMENT_FORM} from "@/store/mutations-types";
	import {getSearchBlogList,getReviewsBlog} from "@/api/blog";
	import {getBlogList} from "@/api/home";
	import {SET_IS_BLOG_TO_HOME} from "../store/mutations-types";
	import router from '../router';
	

	export default {
		name: "Index",
		components: {Header, BlogPasswordDialog, Tocbot, MyAPlayer, RandomBlog, Tags, Nav, Footer, Introduction,Foot},
		data() {
			return {
				siteInfo: {
					blogName: ''
				},
				categoryList: [],
				tagList: [],
				randomBlogList: [],
				topBlogList: [],
				badges: [],
				newBlogList: [],
				hitokoto: {},
				queryString: '',
				queryResult: [],
				mobileHide: true,
				timer: null,
				blogList: [],
				totalPage: 0,
				getBlogListFinish: false,
				value: 4,
				topBlogs:[]
			}
		},
		computed: {
			...mapState(['focusMode'])
		},
		watch: {
			//路由改变时，页面滚动至顶部
			'$route.path'() {
				this.scrollToTop()
			}
		},
		// beforeRouteEnter(to, from, next) {
		// 	next(vm => {
		// 		if (from.name !== 'blog') {
		// 			//其它页面跳转到首页时，重新请求数据
		// 			//设置一个flag，让首页的分页组件指向正确的页码
		// 			vm.$store.commit(SET_IS_BLOG_TO_HOME, false)
		// 			vm.getBlogList()
		// 		} else {
		// 			//如果文章页面是起始访问页，首页将是第一次进入，即缓存不存在，要请求数据
		// 			if (!vm.getBlogListFinish) {
		// 				vm.getBlogList()
		// 			}
		// 			//从文章页面跳转到首页时，使用首页缓存
		// 			vm.$store.commit(SET_IS_BLOG_TO_HOME, true)
		// 		}
		// 	})
		// },
		created() {
			this.getSite()
			// this.getHitokoto()
			//从localStorage恢复之前的评论信息
			this.getBlogList()
			this.getReviewsBlogs()
			this.$store.commit(RESTORE_COMMENT_FORM)
		},
		mounted() {
			//保存可视窗口大小
			this.$store.commit(SAVE_CLIENT_SIZE, {clientHeight: document.body.clientHeight, clientWidth: document.body.clientWidth})
			window.onresize = () => {
				this.$store.commit(SAVE_CLIENT_SIZE, {clientHeight: document.body.clientHeight, clientWidth: document.body.clientWidth})
			}
			this.slideBanner()
		},
		
		methods: {
			getReviewsBlogs() {
				getReviewsBlog().then(res => {
					if(res.code == 200){
						this.topBlogs = res.data
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
			handleClick(event, item) {
				// 判断是否点击的是 router-link 内部元素，避免触发父级 div 的点击事件
				if (event.target.closest('a')) {
					return;
				}
				this.$router.push(`/${item.title}`);
			},
			formatDate(isoString) {
				const date = new Date(isoString);
				const options = { year: 'numeric', month: 'long', day: 'numeric' };
				return date.toLocaleDateString('en-US', options);
			},
			getBlogList(pageNum) {
				getBlogList(pageNum).then(res => {
					if (res.code === 200) {
						this.blogList = res.data.list
						this.totalPage = res.data.totalPage
						console.log(this.blogList)
						// this.$nextTick(() => {
						// 	Prism.highlightAll()
						// })
						// this.getBlogListFinish = true
					} else {
						this.msgError(res.msg)
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
			getSite() {
				getSite().then(res => {
					if (res.code === 200) {
						this.siteInfo = res.data.siteInfo
						this.badges = res.data.badges
						this.newBlogList = res.data.newBlogList
						this.categoryList = res.data.categoryList
						this.tagList = res.data.tagList
						this.randomBlogList = res.data.randomBlogList
						this.topBlogList = res.data.topBlogList
						console.log(this.randomBlogList)
						this.$store.commit(SAVE_SITE_INFO, this.siteInfo)
						this.$store.commit(SAVE_INTRODUCTION, res.data.introduction)
						document.title = this.$route.meta.title + this.siteInfo.webTitleSuffix
					}
				})
			},
			//获取一言
			getHitokoto() {
				getHitokoto().then(res => {
					this.hitokoto = res
				})
			},
			toggle() {
				this.mobileHide = !this.mobileHide
			},
			debounceQuery(queryString, callback) {
				this.timer && clearTimeout(this.timer)
				this.timer = setTimeout(() => this.querySearchAsync(queryString, callback), 1000)
			},
			querySearchAsync(queryString, callback) {
				if (queryString == null
						|| queryString.trim() === ''
						|| queryString.indexOf('%') !== -1
						|| queryString.indexOf('_') !== -1
						|| queryString.indexOf('[') !== -1
						|| queryString.indexOf('#') !== -1
						|| queryString.indexOf('*') !== -1
						|| queryString.trim().length > 20) {
					return
				}
				getSearchBlogList(queryString).then(res => {
					if (res.code === 200) {
						this.queryResult = res.data
						if (this.queryResult.length === 0) {
							this.queryResult.push({title: '无相关搜索结果'})
						}
						callback(this.queryResult)
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
			handleSelect(item) {
				if (item.id) {
					this.$router.push(`/blog/${item.id}`)
				}
			},
			slideBanner() {
				//选中的轮播图
				var box = document.querySelector('.el-carousel__container');
				var startPoint = 0;
				var stopPoint = 0;
				//重置坐标
				var resetPoint = function () {
					startPoint = 0;
					stopPoint = 0;
				}
				//手指按下
				box.addEventListener("touchstart", function (e) {
					//手指点击位置的X坐标
					startPoint = e.changedTouches[0].pageX;
				});
				//手指滑动
				box.addEventListener("touchmove", function (e) {
					//手指滑动后终点位置X的坐标
					stopPoint = e.changedTouches[0].pageX;
				});
				//当手指抬起的时候，判断图片滚动离左右的距离
				let that = this
				box.addEventListener("touchend", function (e) {
					console.log("1：" + startPoint);
					console.log("2：" + stopPoint);
					if (stopPoint == 0 || startPoint - stopPoint == 0) {
					resetPoint();
					return;
					}
					if (startPoint - stopPoint > 0) {
					resetPoint();
					that.$refs.slideCarousel.next();
					return;
					}
					if (startPoint - stopPoint < 0) {
					resetPoint();
					that.$refs.slideCarousel.prev();
					return;
					}
				});
			},
		}
	}
</script>

<style scoped>
	.site {
		display: flex;
		min-height: 100vh; /* 没有元素时，也把页面撑开至100% */
		flex-direction: column;
		
	}

	.main {
		/* margin-top: 40px; */
		flex: 1;
	}

	.main .ui.container {
		width: 1400px !important;
		margin-left: auto !important;
		margin-right: auto !important;
	}
	.container {
		width: 100%;
		/* margin-right: auto; */
		/* margin-left: auto; */
	}

	.ui.grid .three.column {
		padding: 0;
	}

	.ui.grid .ten.column {
		padding-top: 0;
	}

	.m-display-none {
		display: none !important;
	}

	.m-display-none {
		display: none !important;
	}

	.m-search {
		width: 650px;	
		border: 1px solid #eaeaea !important;
		padding: 0 !important;
		margin-right: 7px;
		border-radius: 6px !important;
	}
	
	.m-search input{
		color: #6c6f72 !important;
		/* border: 1px solid #000 !important; */
		background-color: inherit;
		padding: .67857143em 2.1em .67857143em 1em;
		font-size: 16px;
	}

	::v-deep .el-input__inner {
        /* background-color: #e8e8e8; */
        /* text-align: center; */
		height: 50px !important;
        border-color: #c0c4cc;
        color:#000 !important;
		font-size: 16px;
	}
	::v-deep .el-input__inner:focus {
		border-color: #000 !important;
		outline: 0;
	}

	::v-deep .el-input__inner::placeholder {
		color: #6c6f72;
		font-weight: 400;
		font-size: 16px;
	}
	.m-search-item {
		min-width: 350px !important;
	}

	.m-search-item li {
		line-height: normal !important;
		padding: 8px 10px !important;
	}

	.m-search-item li .title {
		text-overflow: ellipsis;
		overflow: hidden;
		color: rgba(0, 0, 0, 0.87);
	}

	.m-search-item li .content {
		text-overflow: ellipsis;
		font-size: 12px;
		color: rgba(0, 0, 0, .70);
	}
	@media (min-width: 768px) {
		.carousel-container {
			width: 40%;
		}
		.most-container{
			width: 100%;
		}
		.header-left{
			width: 70%;
		}
		.header-right{
			width: 30%;
		}
		.header-right-margin{
			margin: 0px 0px 32px 0px;
		}
		.header-left-margin{
			margin: 0px 0px 32px 0px;
		}
		.header-right-center{
			text-align: right;
		}
		.header-left-center{
			text-align: left;
		}
		.col-md-6 {
			flex: 0 0 auto;
			padding: 0 10px 20px 10px;
			width: 50%;
		}
		.container{
			max-width: 720px;
		}
	}
	@media (min-width: 576px) {
		.col-sm-6 {
			flex: 0 0 auto;
			width: 50%;
			padding: 0 10px 20px 10px;
		}
		.container{
			max-width: 540px;
		}
	}
	@media (max-width: 767px) {
		.m-search {
			max-width: 330px !important;
		}
		.carousel-container {
			width: 100%;
		}
		.header-left{
			width: 100%;
		}
		.header-right{
			width: 100%;
		}
		.header-left-margin{
			margin: 0px 0px 32px 0px;
		}
		.header-right-margin{
			margin: 0px 0px 50px 0px;
		}
		.header-right-center{
			text-align: center;
		}
		.header-left-center{
			text-align: center;
		}
		.col-mn-12 {
			flex: 0 0 auto;
			padding: 0 0 20px 0;
			width: 100%;
		}
		.row {
			margin: 10px 0 10px 0;
		}
		.col-13{
			padding: 0 5px 0 0 !important;
		}
		.footer-top-area {
			text-align: left !important;
		}
		.footer-content-area {
			padding-top: 80px !important;
			padding-bottom: 20px !important;
		}
		.container{
			max-width: 320px;
		}
		
	}
	@media (max-width: 1024px) and (min-width: 768px) {
		.carousel-container {
			width: 100%;
		}
		.aside-container {
			width: 100%;
		}
		.blog-image {
			height: 320px;
		}
		.blog-right-image {
			height: 320px;
		}
		.row{
			margin: 15px 0 0 0;
		}
		.most-container{
			max-width: 1024px;
		}
		.col-13{
			padding: 0 5px 0 0 !important;
		}
		.col-lg-6{
			width: 100%;
		}
	}
	@media (min-width: 1024px) {
		.aside-container {
			width: 59.666%;
		}
	}
	@media (min-width: 1200px) {
		.col-xl-3 {
			flex: 0 0 auto;
			width: 25%;
			padding: 0 10px 20px 10px;
			
		}
	}
	@media (min-width: 992px) {
		.col-lg-6 {
			flex: 0 0 auto;
			width: 50%;
		}
		.col-lg-3 {
			flex: 0 0 auto;
			width: 25%;
			padding: 0 10px 20px 10px;
		}
		.container{
			max-width: 960px;
		}
	}
	.custom-carousel-item:hover .carousel-bg {
		transform: scale(1.1); 
	}
	.carousel-bg {
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
		border-radius: 10px;
		position: absolute;
		top: 0;
		left: 0;
		transition: transform 0.5s ease-in-out;
	}
	.post-terms {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px;
		margin-bottom: 13px;
	}
	.post-terms a {
		display: inline-block;
		color: #777777;
		font-size: 12px;
		font-weight: 500;
		letter-spacing: 0.8px;
		line-height: 1;
	}
	.category-style {
		display: inline-flex;
		font-size: 14px;
		color: #fff;
		border-radius: 4px;
		padding: 8px 15px 8px;
		font-weight: 500;
		letter-spacing: 0.7px;
		line-height: 1;
		transition: all 0.3s ease-in-out;
	}

	
	.gradient-overlay {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.8) 100%);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		border-radius: 10px;
	}
	.row {
		display: flex;
		flex-wrap: wrap;
		/* margin-top: calc(-1* 1.5rem);
		margin-right: calc(-.5* 1.5rem);
		margin-left: calc(-.5* 1.5rem); */
	}

	.col-12 {
		/* display: flex; */
		flex: 0 0 auto;
		padding: 0 5px 0 0;
		width: 100%;
	}
	.col-13 {
		/* display: flex; */
		flex: 0 0 auto;
		padding: 0 5px 0 20px;
		width: 100%;
	}
	.blog-image {
		width: 100%;
		height: 225px;
		object-fit: cover;
		transform: scale(1.02);
		transition: transform 1s cubic-bezier(0.25, 0.8, 0.25, 1);
	}
	
	.blog-right-image {
		width: 100%;
		height: 350px;
		object-fit: cover;
		transform: scale(1.02);
		transition: transform 1s cubic-bezier(0.25, 0.8, 0.25, 1);
	}
	.image-wrapper:hover .blog-image {
		transform: scale(1.1);
	}
	.image-wrapper:hover .blog-right-image {
		transform: scale(1.1);
	}
	.most-container{
    	width: 100%;
	}
	.line {
		position: relative;
		width: 4px;
		border-radius: 4px;
		display: inline-block;
		margin-right: 10px;
		background-color: #2c3e50;
		height: 27px;
	}
	.all-container{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}
	.rt-item {
		position: relative;
		background-color: #fff;
		border-radius: 10px;
		box-shadow: 0px 0px 35px rgb(0 0 0 / 5%);
		overflow: hidden;
		transition: all ease 0.31s;
	}
	.rt-item .rt-image {
		position: relative;
		overflow: hidden;
		cursor: pointer;
	}
	.rt-item .rt-image img {
		min-height: 380px;
		width: 100%;
		height: 100%;
		object-fit: cover;
		transform: scale(1.02);
		transition: transform 1s cubic-bezier(0.25, 0.8, 0.25, 1);
		max-width: 100%;
		border: none;
		border-radius: 0;
		box-shadow: none;
	}
	.rt-item:hover .rt-main-image {
		transform: scale(1.1);
	}
	ul.entry-meta {
		list-style: none;
		margin-bottom: 0;
		margin-top: 5px;
		margin-left: 0;
		padding-left: 0;
	}
	ul.entry-meta li {
		display: inline-block;
		color: #777777;
		font-size: 14px;
		font-weight: bold;
		letter-spacing: 0.2px;
		line-height: 1.2;
		margin-right: 10px;
		text-transform: capitalize;
		transition: all ease 0.31s;
	}
	.footer-area {
		position: relative;
		overflow: hidden;
		display: block;
	}
	.footer-shape .shape1 {
		left: 0px;
		bottom: 1px;
	}
	.footer-shape .shape2 {
		left: 420px;
		top: 30px;
	}
	.footer-shape .shape3 {
		right: 595px;
		bottom: 30px;
	}
	.footer-shape .shape4 {
		right: 468px;
		bottom: 119px;
	}
	.footer-shape .shape5 {
		right: 66px;
		bottom: 1px;
	}
	.footer-shape .shape {
		position: absolute;
	}
	.footer-content-area {
		font-size: 16px;
		border-top: none;
		padding: 100px 0px 40px;
	}
	@media (min-width: 1400px) {
		.container {
			max-width: 1200px !important;
		}
	}
	@media (min-width: 1200px) {
		.container{
			max-width: 1140px;
		}
	}
	.footer-area .widget_text {
		margin-bottom: 20px;
	}

	.footer-top-area .widget {
		margin-bottom: 20px;
		padding-bottom: 0px;
		width: 100%;
		position: relative;
	}
	.footer-content-area * {
		text-align: center;
	}

	.widget {
		margin: 0 0 1.5em;
	}
	h1 {
		font-size: 44px;
		line-height: 54px;
		font-style: normal;
		font-family: 'Inter', sans-serif;
		font-weight: 600;
		margin: 0 0 20px;
	}
	@media (min-width: 992px) {
		.footer-area .footer-about {
			margin-right: 40px;
		}
	}

	.footer-area .footer-about {
		margin-bottom: 28px;
	}
	.widget ul {
		list-style-type: none;
		margin: 0px;
		padding: 0px;
	}
	.footer-area .footer-social li {
		display: inline-block;
		margin-right: 7px;
		margin-bottom: 0px;
		padding-bottom: 0px;
		transition: 0.31s;
		position: relative;
		line-height: 1.6;
	}
	.footer-top-area ul li {
		margin-bottom: 8px;
		padding-bottom: 8px;
		position: relative;
		line-height: 1.6;
	}
	.footer-area .footer-social li a {
    	display: flex;
		align-items: center;
		justify-content: center;
		height: 40px;
		width: 40px;
		font-size: 15px;
		text-align: center;
		color: rgb(152, 155, 173);
		background: transparent;
		border-width: 1px;
		border-style: solid;
		border-color: rgb(152, 155, 173);
		border-image: initial;
		border-radius: 50%;
		transition: 0.4s;
		text-decoration: none;
		color: #989bad;
	}
	.container .row{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
	.footer-social li a svg{
		width: 16px;
		height:16px;
	}
	.footer-copyright-area {
		font-size: 17px;
		text-align: center;
		position: relative;
		border-top: 1px solid rgb(43, 46, 66);
		padding: 25px 0px;
	}
	.copyright-area {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}
	.footer-area .copyright {
		color: #989bad;
	}

	.footer-area .copyright {
		color: rgb(152, 155, 173);
		text-align: center;
	}
	.copyright-area .widget {
		margin-bottom: 0px;
	}
	.copyright-area .copyright-menu ul {
		display: inline-flex;
		align-items: center;
		gap: 12px;
	}
	.copyright-area .copyright-menu ul li {
		margin-bottom: 0px;
		padding-bottom: 0px;
	}
	.footer-top-area .copyright-area .copyright-menu ul li:first-child a {
		padding-left: 0px;
	}
	.footer-top-area .widget ul.menu li a {
		display: inline-block;
		position: relative;
		transition: 140ms ease-in-out;
	}
	.footer-top-area .widget a{
		color: #989bad;
	}
	.rt_footer_social_widget{
		margin-bottom: 60px !important;
	}
	::v-deep .off .el-rate__item{
		display: none !important;
	}
	.button-style-3{
		background-color: rgba(44, 62, 80, 0.08);
		color: #2c3e50;
		position: relative;
		font-size: 15px;
		font-weight: 600;
		letter-spacing: 0.5px;
		border-radius: 6px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		padding: 10px 18px;
		line-height: 1.4;
		z-index: 1;
		overflow: hidden;
		border: none;
		cursor: pointer;
	}
	.button-style-3:hover{
		color: #fff;
	}
	

	.button-style-3::before {
		content: "";
		position: absolute;
		top: 0;
		left: -100%;
		width: 100%;
		height: 100%;
		background-color: #2c3e50;
		transition: left 0.3s ease-in-out;
		z-index: -1;
	}


	.button-style-3:hover::before {
		left: 0;
	}
</style>